/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, ViewRef} from '@angular/core';

/**
 * Runs detectChanges only if the view is still alive.
 * Components can finish HTTP / timeout work after navigation has already
 * destroyed the view (ViewDestroyedError in prod).
 */
export function safeDetectChanges(cdr: ChangeDetectorRef): void {
  const view = cdr as ViewRef;
  if (view.destroyed) {
    return;
  }
  view.detectChanges();
}
